import Form from 'react-bootstrap/Form'
import SelectActividades from '../SelectActividades'
import { Button, Col } from 'react-bootstrap'
import React from 'react'
import { useFieldArray } from 'react-hook-form'

export default function ActividadesSecundariasHooks(props) {
  const whatAre = props.isHabilitacion ? 'habilitacion' : 'legajo'
  const whatIs = props.isHabilitacion ? 'habilitacion' : 'legajo'
  const {
    fields: actividadesSecundarias,
    remove: quitarActividadSecundaria,
    append: agregarActividadSecundaria
  } = useFieldArray({
    control: props.control,
    name: `${props.listado}.${whatAre}.actividadSecundaria`
  })

  return (
    <>
      {actividadesSecundarias.map((actividadSecundariaID, indexAS) => (
        <Col md={6} key={actividadSecundariaID.id}>
          <Form.Group
            controlId={
              'form' + whatIs + '-' + props.nestIndex + 'actividadSecundaria'
            }
          >
            <Form.Label>
              Actividad Secundaria {indexAS + 1}
              {!props.isDisabled && (
                <a href="#/" onClick={() => quitarActividadSecundaria(indexAS)}>
                  (eliminar)
                </a>
              )}
            </Form.Label>
            <SelectActividades
              actividadesiibb={props.actividadesiibb}
              defaultValue={{ ...actividadSecundariaID, id: undefined }}
              register={props.register}
              name={`${
                props.listado
              }.${whatAre}.actividadSecundaria.[${indexAS}].[${
                Object.keys(actividadSecundariaID)[0]
              }]`}
              isDisabled={props.isDisabled}
            />
          </Form.Group>
        </Col>
      ))}
      {!props.isDisabled && (
        <Col lg={6} sm={12} mt={4}>
          <Button
            className={'btn btn-block margin-top-1x margin-bottom-1x'}
            variant="outline-primary"
            onClick={() => agregarActividadSecundaria({})}
          >
            Agregar Actividad Secundaria en {whatIs} N° {props.nestIndex + 1}
          </Button>
        </Col>
      )}
    </>
  )
}
